import React from "react";

import WorkoutAnalysisTable from "./WorkoutAnalysisTable";
import {
  getGeneralInfoTableData,
  getInjuryReportTableData
} from "../../helpers";
import Loader from "components/Loader";
import { useRacehorse360Api } from "hooks/api";
import useStyles from "./styles";

interface IProps {
  selectedTrackOpticsVideoId: string;
}

const WorkoutAnalysisResults = (props: IProps) => {
  const { selectedTrackOpticsVideoId } = props;

  const classes = useStyles();
  const { useGetTrackOpticsVideo } = useRacehorse360Api();

  const { data: selectedVideo, isLoading } = useGetTrackOpticsVideo({
    id: selectedTrackOpticsVideoId,
    getOptions: {
      select: [
        "horseNameOrRegistrationNumber",
        "date",
        "facility.name",
        "injuryEntry.description",
        "injurySeverity.description",
        "injurySeverity.value",
        "limb.description",
        "stride.description",
        "comment",
        "injuryReportDate",
        "injuryReportCreator.firstName",
        "injuryReportCreator.lastName"
      ]
    }
  });

  if (!selectedVideo && isLoading) return <Loader className={classes.loader} />;

  return (
    <>
      <WorkoutAnalysisTable
        className={classes.generalInfoTable}
        title={"General Info"}
        rows={getGeneralInfoTableData(selectedVideo)}
      />
      <WorkoutAnalysisTable
        title={"Injury Report"}
        rows={getInjuryReportTableData(selectedVideo)}
      />
    </>
  );
};

export default React.memo(WorkoutAnalysisResults);
